import { isSsr } from '@lemonade-hq/cdk';

export const GIVEBACK2019_MOBILE_BREAKPOINT = 1024;
export const GIVEBACK2019_DESKTOP_BREAKPOINT = GIVEBACK2019_MOBILE_BREAKPOINT + 1;

export function isInGiveback2019MobileViewport() {
  if (isSsr()) return false;
  return window.innerWidth < GIVEBACK2019_DESKTOP_BREAKPOINT;
}

export function isInViewport(elements: { el: HTMLElement; offset?: number }[]): boolean | null {
  if (isSsr()) return false;

  let isIt: boolean | null = null;

  elements.forEach(({ el, offset = 0 }) => {
    if (!el) {
      isIt = true;
    } else {
      const { top, bottom, height } = el.getBoundingClientRect();
      const { innerHeight } = window;
      const topLimit = top + height - offset;
      const bottomLimit = bottom - height;

      isIt = isIt || (topLimit >= 0 && bottomLimit <= innerHeight);
    }
  });

  return isIt;
}
